export const customerReviews = [
  {
    name: "Ravi Mehta",
    location: "Jaipur, Rajasthan",
    message: "Super easy to order medicines! The delivery was quick, and I got real-time updates. Great service!",
  },
  {
    name: "Pooja Sharma",
    location: "Jaipur, Rajasthan",
    message: "Booking a lab test was never this simple! The app is smooth and easy to navigate. Loved it!",
  },
  {
    name: "Vikram Rathore",
    location: "Jaipur, Rajasthan",
    message: "Affordable prices and fast medicine delivery. Highly recommend this app for all medical needs.",
  },
  {
    name: "Anjali Gupta",
    location: "Jaipur, Rajasthan",
    message: "Needed urgent medicine at night, and this app saved me. Fast service and reliable pharmacy options!",
  },
  {
    name: "Ramesh Singh",
    location: "Jaipur, Rajasthan",
    message: "Best pharmacy booking experience ever! No need to visit stores anymore. Everything is at my fingertips!",
  },
];